import { baseInstance } from './baseInstance';

export const getMyOrders = (data) => {
    return baseInstance.post('/Order/MyOrders', data);
};

export const getOrderDetails = (id) => {
    return baseInstance.get('/Order/OrderDetails/' + id);
};